import { perlickConstant } from "config/Perlick.Constant";

export const PerlickCHColumns = () => {
  return [
    {
      title: "Quote Date",
      dataIndex: "quotedate",
      key: "quotedate",
      className: "quote-date-col",
      datatype: perlickConstant.Datatype.datetime,
    },
    {
      title: "Sold-to Name",
      dataIndex: "soldtoname",
      key: "soldtoname",
      datatype: perlickConstant.Datatype.string,
    },
    {
      title: "Job Name",
      dataIndex: "jobname",
      key: "jobname",
      datatype: perlickConstant.Datatype.string,
    },
    {
      title: "PO Number",
      dataIndex: "ponum",
      key: "ponum",
      datatype: perlickConstant.Datatype.number,
    },
    {
      title: "Job City",
      dataIndex: "jobcity",
      key: "jobcity",
      hidden: true,
      datatype: perlickConstant.Datatype.string,
    },
    {
      title: "Job State",
      dataIndex: "jobstate",
      key: "jobstate",
      hidden: true,
      datatype: perlickConstant.Datatype.string,
    },
    {
      title: "Serial Number",
      dataIndex: "serialno",
      key: "serialno",
      hidden: true,
      datatype: perlickConstant.Datatype.string,
    },
    {
      title: "Order Number",
      dataIndex: "ordno",
      key: "ordno",
      hidden: true,
      datatype: perlickConstant.Datatype.string,
    },
    {
      title: "System Id",
      dataIndex: "sysid",
      key: "sysid",
      hidden: true,
      datatype: perlickConstant.Datatype.number,
    },
  ];
};

export const PerlickTrunkList = () => {
  return [
    {
      title: "Trunk Number",
      dataIndex: "TrunkNo",
      key: "TrunkNo",
    },
    {
      title: "Heads",
      dataIndex: "NoHeads",
      key: "NoHeads",
    },
    {
      title: "Comments",
      dataIndex: "LineComments",
      key: "LineComments",
    },
  ];
};

export const PerlickTrunkDetailList = () => {
  return [
    {
      title: "Line Number",
      dataIndex: "LineNumber",
      key: "LineNumber",
    },
    {
      title: "Line Label",
      dataIndex: "LineLabel",
      key: "LineLabel",
    },
    {
      title: "Head No.",
      dataIndex: "HeadNo",
      key: "HeadNo",
    },
    {
      title: "Overall Length",
      dataIndex: "OverallLength",
      key: "OverallLength",
    },
    {
      title: "Segment Length",
      dataIndex: "SegmentLength",
      key: "SegmentLength",
    },
    {
      title: "Segments",
      dataIndex: "Segments",
      key: "Segments",
    },
    {
      title: "Applied Pressure",
      dataIndex: "AppliedPressure",
      key: "AppliedPressure",
    },
  ];
};
